// extracted by css-extract-rspack-plugin
export default {"printHide":"_c2769bb1"};